import { useState } from "react";
import ScrollToTop from "./component/ScrollToTop/ScrollToTop";
import { useInputValidation } from "./hooks/useInputValidation";
import { AppRoutes } from "./routes";

function App() {
  const [programDetailsId, setProgramDetailsId] = useState(null);
  useInputValidation();

  return (
    <ScrollToTop>
      <AppRoutes
        routeContext={{
          programDetailsId,
          setProgramDetailsId,
        }}
      />
    </ScrollToTop>
  );
}

export default App;
